import { faCircle, faCircleNotch, faStopCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { Button, FormGroup, Modal } from "react-bootstrap";
import { CheckSquare } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { sendInvoiceToTaxOffice } from "../store/api/Invoice";

/**
 * 
 * @param {{
 * modalData:{show:boolean, 
 * invoiceData:{InvoiceID: bigint, 
 * InvoiceType: invoiceTypes}}, 
 * onSuccess:function
 * setModalData:funtion, 
 * pending:boolean, 
 * setPending:function}} param0 
 * @returns 
 */
const ModalInvoiceCancel = ({ modalData, setModalData, pending, setPending }) => {
    const cancelDate = useRef();
    const close = () => {
        setModalData({
            show: false
        })
    }
    function cancelInvoice() {
        if (pending) {
            return;
        }
        setPending(true);
        const onSuccess =(res)=>{
            modalData.onSuccess?.(res);
            close();
        }
        sendInvoiceToTaxOffice({
            ...modalData.invoiceData,
            CancelInvoice: true,
            CancelDate:cancelDate.current,
            SendCustomerInfo: true
        }, onSuccess);
    }
    return (
        <Modal show={modalData.show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faStopCircle} size="lg" />&nbsp;
                    ابطال فاکتور
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />

            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <FormGroup>
                    <label>تاریخ و ساعت ابطال:</label>
                    <DatePicker
                        isGregorian={false}
                        timePicker={true}
                        className="form-control"
                        inputJalaaliFormat="jYYYY/jMM/jDD HH:mm"
                        onChange={value => cancelDate.current = value.local("en").format("YYYY-MM-DD HH:mm")}
                    />
                </FormGroup>
                <Button className="group-Btn-large mt-2" onClick={cancelInvoice} disabled={pending}><CheckSquare size={18} /> ابطال فاکتور</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalInvoiceCancel;